module.exports = __webpack_public_path__ + "img/inviteFailure.9a3218a9.png";